module.exports = __webpack_public_path__ + "21d5b8b43c5973a35af84d7bc15cfa8c.svg";